import { Ds, Tokens } from "@accurx/design";
import styled from "styled-components";

export const PageContainer = styled(Ds.Flex).attrs(() => ({
    flexDirection: "column",
    gap: { xs: "2", md: "3" },
}))`
    padding: 1.5rem 1rem;

    @media (min-width: ${Tokens.BREAKPOINTS.md}) {
        padding: 1.5rem 1.5rem;
    }
`;

export const AppointmentReminderStatusWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: ${Tokens.SIZES[1]};
    margin-bottom: ${Tokens.SIZES[1]};
`;

export const AppointmentReminderSelectWrapper = styled.div`
    min-width: 160px;
`;

export const SearchInputWrapper = styled.div`
    flex-grow: 1;
`;

export const StyledPaginationContainer = styled.div`
    display: flex;
    justify-content: right;
    margin-top: 1rem;
    padding-bottom: 3rem;
`;

export const StyledSpinnerPosition = styled(Ds.Flex)`
    justify-content: center;
`;

export const RoundedMessageBox = styled(Ds.Box)`
    border-radius: var(--ds-border-radius);
    white-space: pre-wrap;
`;

export const VerticalResizeTextarea = styled(Ds.Textarea)`
    resize: vertical;
    border-radius: inherit;

    ${({ isInvalid }) =>
        isInvalid ? `background-color: var(--ds-color-red-5);` : ""}
`;

export const FragmentsText = styled(Ds.Text)`
    white-space: nowrap;
    text-align: right;
`;
